import { LinkButton } from "@/ui/next/LinkButton";
import { useTranslation } from "next-i18next";

import HeartIcon from "@/assets/icons/24/heart/Filled";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { useHomepageMarketingCollection } from "@/components/Homepage/hooks/useHomepageMarketingCollection.hooks";
import Image from "@/components/common/Image";
import { Heading } from "@/ui/cva/Heading";
import { Body } from "@/ui/typography/Body";

export const HomepageMarketingBlock = () => {
  const { t } = useTranslation();
  const { marketingCollection } = useHomepageMarketingCollection();

  const handleMarketingClick = () => {
    /** Trigger `hp_marketing_banner` event. */
    analyticsService.trackHpMarketingBanner();
  };

  if (!marketingCollection) {
    return null;
  }

  const marketingBlockLink = marketingCollection.listingPage
    ? `/${marketingCollection.listingPage.url}`
    : null;

  return (
    <section className="grid overflow-hidden md:h-[28.75rem] md:grid-cols-[6fr_4fr] md:rounded-b-[0.25rem]">
      <div className="relative min-h-80 md:min-h-[auto]">
        {/*
         * On desktop this image, not the hero, is the LCP element (the hero
         * sits beside the copy, this block spans 60% of the viewport). Lazy
         * loading it cost ~0.8s of LCP in the 2026-08-01 audit, so fetch it
         * eagerly; the hero keeps fetchpriority="high" because only one
         * image should claim it.
         */}
        <Image
          src={marketingCollection.image}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          alt={marketingCollection.title}
          loading="eager"
        />
      </div>
      <div className="flex flex-col items-center justify-center space-y-4 bg-flavour-50 px-4 py-10 text-center md:px-10 md:py-4">
        <HeartIcon className="h-10 w-10 text-attention-500" />
        <Heading as="h2">{marketingCollection.title}</Heading>
        {marketingCollection.description && (
          <Body>{marketingCollection.description}</Body>
        )}
        {marketingBlockLink && (
          <LinkButton
            href={marketingBlockLink}
            appearance="minimal"
            onClick={handleMarketingClick}
          >
            {t("homepage:homepage-collections-block-link")}
          </LinkButton>
        )}
      </div>
    </section>
  );
};
